import { render, staticRenderFns } from "./SimpleNavigationBar.vue?vue&type=template&id=55348e56&scoped=true"
import script from "./SimpleNavigationBar.vue?vue&type=script&lang=js"
export * from "./SimpleNavigationBar.vue?vue&type=script&lang=js"
import style0 from "./SimpleNavigationBar.vue?vue&type=style&index=0&id=55348e56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55348e56",
  null
  
)

export default component.exports